export enum ChoosedayState
{
  Idle = 0,
  Pick = 1,
  Play = 2,
  TieBreak = 3,
}

export interface ChoosedayRoll
{
    user: string;
    roll: number;
}

export type ChoosedayRolls = Array<ChoosedayRoll>;
